import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import AcademicComp from './AcademicComp'

function Academic() {
  return (
    <div>
         <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <AdmissionTopNotice/>
              <AcademicComp/>

            </div>
        </div>  
    </div>
  )
}

export default Academic